import loc, { format } from 'owa-localize';
import {
    infobarAcceptedByDelegate,
    infobarTentativelyAcceptedByDelegate,
    infobarDeclinedByDelegate,
} from './allViewStates.locstring.json';
import { formatUserTime, formatWeekDayDate } from 'owa-datetime';
import { GetInfoBarViewStatesProps } from './allViewStates';
import { InfoBarMessageRank, InfoBarMessageSource, InfoBarMessageViewState } from 'owa-info-bar';

export function getMeetingResponseByDelegate(
    options: GetInfoBarViewStatesProps
): InfoBarMessageViewState {
    const message = getMeetingResponseMessage(options);
    return {
        key: 'InfoMeetingResponseByDelegate',
        message,
        messageParts: message ? [message] : [],
        rank: InfoBarMessageRank.Info,
        source: InfoBarMessageSource.Compose,
    };
}

export function getMeetingResponseMessage(options: GetInfoBarViewStatesProps): string {
    let message = null;
    switch (options.appointmentResponseType) {
        case 'Accept':
            message = loc(infobarAcceptedByDelegate);
            break;
        case 'Tentative':
            message = loc(infobarTentativelyAcceptedByDelegate);
            break;
        case 'Decline':
            message = loc(infobarDeclinedByDelegate);
            break;
    }
    message = message
        ? format(
              message,
              options.appointmentReplyName,
              formatWeekDayDate(options.appointmentReplyDate),
              formatUserTime(options.appointmentReplyDate)
          )
        : null;
    return message;
}
